export const getFormDirection = (i18n) => {
  const currentLanguage = (
    i18n?.resolvedLanguage ||
    i18n?.language ||
    localStorage.getItem("i18nextLng") ||
    "en"
  ).split("-")[0];
  const isRTL = ["ps", "dr"].includes(currentLanguage);

  return {
    isRTL,
    fieldDirection: isRTL ? "rtl" : "ltr",
    fieldTextAlign: isRTL ? "right" : "left",
  };
};

export const getRtlTextFieldProps = (
  { isRTL, fieldDirection, fieldTextAlign },
  { inputProps = {}, InputLabelProps = {}, sx = {} } = {}
) => ({
  inputProps: {
    ...inputProps,
    dir: fieldDirection,
    style: {
      ...(inputProps.style || {}),
      textAlign: fieldTextAlign,
    },
  },
  InputLabelProps: {
    ...InputLabelProps,
    sx: {
      direction: fieldDirection,
      right: isRTL ? 24 : "auto",
      left: isRTL ? "auto" : undefined,
      transformOrigin: isRTL ? "top right" : "top left",
      ...(InputLabelProps.sx || {}),
    },
  },
  sx: {
    direction: fieldDirection,
    "& .MuiOutlinedInput-root": {
      direction: fieldDirection,
    },
    "& .MuiInputBase-input": {
      textAlign: fieldTextAlign,
    },
    "& .MuiInputLabel-root": {
      textAlign: fieldTextAlign,
    },
    ...sx,
  },
});

export const getRtlSelectProps = ({ fieldDirection, fieldTextAlign }) => ({
  MenuProps: {
    PaperProps: {
      sx: { direction: fieldDirection, textAlign: fieldTextAlign },
    },
  },
});
